import { Validator } from './Validator';
import { ReactError } from 'consts/ReactError';

export type FormErrors = {
	mailaddress_1: string;
	lastname: string;
	firstname: string;
	kana_lastname: string;
	kana_firstname: string;
	sex: string;
	tel: string;
	zip: string;
	pref_cd: string;
	address_2: string;
	address_3: string;
	address_4: string;
	nickname: string;
	country: string;
	birthYear: string;
	birthMonth: string;
	birthDate: string;
	// directmail_flg: string;
	// data_util_agree_flg: string;
};

export const initialFormErrors: FormErrors = {
	mailaddress_1: '',
	lastname: '',
	firstname: '',
	kana_lastname: '',
	kana_firstname: '',
	sex: '',
	tel: '',
	zip: '',
	pref_cd: '',
	address_2: '',
	address_3: '',
	address_4: '',
	nickname: '',
	country: '',
	birthYear: '',
	birthMonth: '',
	birthDate: '',
	// directmail_flg: '',
	// data_util_agree_flg: '',
};

export const getErrorMessage = <T>(name: string, value: T, displayType: number): string => {
	const validator = new Validator(value);
	const isRequired = 1 === displayType;
	const isNone = 3 === displayType;
	// 非表示項目の場合スルー
	if (isNone) {
		return '';
	}
	switch (name) {
		case 'mailaddress_1':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeEmail().end();
		case 'lastname':
		case 'firstname':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeFullWidth(ReactError.E0007).end();
		case 'kana_lastname':
		case 'kana_firstname':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeFullWidthKana(ReactError.E0006).end();
		case 'tel':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeTel().end();
		case 'zip':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeZip().end();
		case 'address_2':
		case 'address_3':
		case 'address_4':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeFullWidth().end();
		case 'nickname':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeNickName().end();
		default:
			if (isRequired) {
				return validator.require().end();
			}
			return '';
	}
};
